import * as React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { useAuthProvider } from '../Components/AuthProvider';

export type PrivateRouteProps = RouteProps & {}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ ...props }) => {
    const authProvider = useAuthProvider();

    const hasAuth = () => {
        return authProvider?.hasAuth;
    }

    return (
        hasAuth()
        ? <Route {...props} />
        : (
            <Redirect
                to={{
                    pathname: "/Login",
                    state: { 
                        referrer: props.location,
                        message: "Acesso não autorizado",
                        messageVariant: "error"
                    }
                }}
            />            
        )
    );
};

export default PrivateRoute;